module.exports = __webpack_public_path__ + "img/07.e5abe20f.png";